import { faCheck, faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import { FunctionComponent, useState } from 'react';
import styles from './OpsStatusTabsSelect.module.scss';

export interface OpsStatusTabOption {
    id: string;
    name: string;
    count: number;
}

interface OpsStatusTabsSelectProps {
    value: string;
    options: Array<OpsStatusTabOption>;
    className?: string;
    onChange?: (tabId: string) => void;
}

export const OpsStatusTabsSelect: FunctionComponent<OpsStatusTabsSelectProps> = props => {
    const [open, setOpen] = useState(false);

    const selected = props.options.find(option => option.id === props.value);

    const handleSelect = (id: string) => {
        if (id !== props.value) {
            props.onChange?.(id);
        }
    };

    return (
        <Dropdown
            open={open}
            onOpenChange={setOpen}
        >
            <DropdownTrigger className={props.className}>
                <div className={styles.bubble}>
                    <span className={styles.label}>
                        {selected?.name ?? '—'} ({selected?.count ?? 0})
                    </span>
                    <FontAwesomeIcon
                        icon={faChevronDown}
                        className={clsx(styles.chevron, { [styles.chevronOpen]: open })}
                    />
                </div>
            </DropdownTrigger>

            <DropdownContent
                minWidth={200}
                align="start"
                sideOffset={6}
            >
                {props.options.map(option => (
                    <DropdownItem
                        key={option.id}
                        rightIcon={option.id === props.value ? faCheck : undefined}
                        onSelect={() => handleSelect(option.id)}
                    >
                        {`${option.name} (${option.count})`}
                    </DropdownItem>
                ))}
            </DropdownContent>
        </Dropdown>
    );
};

export default OpsStatusTabsSelect;
